/**
 * ScrollController
 *
 * @author Manuel Müller <manuel.mueller@pluswerk.ag>
 */
Pluswerk.PlusProject.Navigation.ScrollController = function () {
  var $scrollToTop = $('.js-scrollToTop');
  var $scrollToMain = $('.js-scrollToMain');

  $scrollToTop.on('click', function () {
    $('html, body').animate({
      scrollTop: 0
    }, 'medium');
    return false;
  });

  $scrollToMain.on('click', function (event) {
    event.preventDefault();
    $('html, body').animate({
      scrollTop: $($.attr(this, 'href')).offset().top - 40
    }, 'medium');
    return false;
  });

  var position = $(window).scrollTop();
  if (position === 0) {
    $scrollToMain.addClass('scrollToMain--isTop');
  }

  $(window).scroll(function () {
    var scroll = $(window).scrollTop();

    if (scroll === 0) {
      $scrollToMain.addClass('scrollToMain--isTop');
    } else {
      $scrollToMain.removeClass('scrollToMain--isTop');
    }
  });
};
